import { MapModel } from './map.model';
import { Task, TaskType } from '../modules/go/model/task.model';

export type UserMail = string;
export type DateISO = string;
export interface ToolbarMenu {
  labelKey: string;
  svgIcon?: string;
  icon?: string;
  link: string;
  extraLabel?: string | number;
}

export interface PromptDataModel {
  content: string;
  contentParam?: string;
  headerParam?: string;
  cancelBtn?: string;
  confirmBtn?: string;
  header: string;
  hideCancelBtn?: boolean;
}

export interface BaseContent {
  content: string;
}

export interface BaseModel {
  id: string | number;
  name: string;
}

export interface SearchableOption<T> extends BaseModel {
  advancedValue?: T;
}

export interface UserModel {
  id: string,
  email: string,
  userName: string,
  firstName: string,
  lastName: string,
  department?: string;
}

export type BaseAttribute = Record<string, string | null>;

export interface ExtraData {
  importAuthor: UserMail;
  importFilename: string;
  importDate: DateISO;
  usedInOrder: number;
}

export interface PdfBaseModel {
  lineExternalId: string;
  linePdfId: number;
}

export interface PowerLineConfig extends MapModel {
  onlyTasks?: boolean;
  zoom?: boolean;
}

export const LIST_SEARCH_MODE = {
  ACTIVE: 'ACTIVE',
  ARCHIVED: 'ARCHIVED',
  ALL: 'ALL',
  EXTERNAL: 'EXTERNAL',
} as const;

export type ListSearchMode = keyof typeof LIST_SEARCH_MODE;

export interface KeyValueItem {
  key: string;
  value: string | null;
}

export interface BuildInfoModel {
  branch: string;
  commitId: string;
  commitTime: DateISO;
}

export interface AppVersionInfo {
  feVersion: string;
  beVersion: string;
}

export interface MapItemData {
  attributes: BaseAttribute;
  tasks: Task[];
  isDynamicControl?: boolean;
  type: TaskType;
  latitude?: number;
  longitude?: number;
}

export interface Location {
  latitude: number;
  longitude: number;
}

export interface BaseControlModel {
  id: string;
  value: string;
  previousValue: string;
}
